import { TFunction } from 'i18next/typescript/t';
import { ImgHTMLAttributes, ReactNode } from 'react';
import { CSSProp } from 'styled-components';
import tw from 'twin.macro';

interface Type {
  title: ReactNode;
  description: ReactNode;
  css?: CSSProp;
  imageProps: ImgHTMLAttributes<HTMLImageElement>;
}

export const typeData = (t: TFunction<'translation', undefined>): Type[] => {
  return [
    {
      title: t('memberType.regular.title'),
      imageProps: {
        src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type1.png`,
        srcSet: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type1.png 1x, ${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type1@2x.png 2x`,
        alt: t('memberType.regular.alt'),
      },
      description: (
        <p css={tw`whitespace-pre-line`}>{t('memberType.regular.desc')}</p>
      ),
    },
    {
      title: t('memberType.associate.title'),
      imageProps: {
        src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type2.png`,
        srcSet: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type2.png 1x, ${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type2@2x.png 2x`,
        alt: t('memberType.associate.alt'),
      },
      description: <p>{t('memberType.associate.desc')}</p>,
    },
    {
      title: t('memberType.special.title'),
      css: [tw`col-span-2 md:col-span-1 mt-[20px] md:mt-0`],
      imageProps: {
        src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type3.png`,
        srcSet: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type3.png 1x, ${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/types/type3@2x.png 2x`,
        alt: t('memberType.special.alt'),
      },
      description: <p>{t('memberType.special.desc')}</p>,
    },
  ];
};
